import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    "model-value": _ctx.formattedValue ?? '',
    ref: "inputRef",
    type: _ctx.inputType,
    name: _ctx.name,
    disabled: _ctx.isDisabled,
    class: _normalizeClass([_ctx.classStr]),
    placeholder: _ctx.placeholder,
    onInput: _ctx.handleInput,
    onChange: _ctx.handleChange,
    onBlur: _ctx.handleBlur,
    onFocus: _ctx.handleFocus
  }, null, 8, ["model-value", "type", "name", "disabled", "class", "placeholder", "onInput", "onChange", "onBlur", "onFocus"]))
}